<template>
    <div id="aboutCashOut">
        <Headers :headersText='headersText'></Headers>
        <div class="boxPadding">
            <div class="explain">
                <div class="text">
                    <div class="title">(1)提现为何没到账？</div>
                    <div class="content">&emsp;a.钱大师每日提现限制次数一次；</div>
                    <div class="content">&emsp;b.用户申请体现后提现到账时间分两种情况：用户于周一至周四提现，则到账时间为次日24点之前、用户于周五、周六、周日申请提现，则到账时间为下周一24点之前；</div>
                    <div class="content">&emsp;c.如遇国家法定节假日，到账时间在钱大师首页公告栏进行公布；</div>
                    <div class="content">&emsp;d.如遇正常提现未按规定到账的情况请及时联系客服</div>
                    <div class="title">(2)提现姓名和支付宝中绑定的姓名不一致？</div>
                    <div class="content">&emsp;请按我们的提现流程正确填写个人信息，提现姓名填错的用户我们是不予修改账户姓名的。针对支付宝账户填写有误的用户请联系客服，每人仅限一次修改机会。即：提现姓名=支付宝账户姓名=身份证姓名。</div>
                    <div class="title">(3)需要更换手机号码？</div>                
                    <div class="content">&emsp;如果您的注册时间是在2018年7月以前，并且首次更换手机号，可将您的需求反馈给我们的客服人员进行更换。</div>
                    <!--<div class="title">(4)需要微信提现？</div>
                    <div class="content">&emsp;钱大师老用户（2019年5月前注册）微信提现可以正常使用，新用户暂不支持微信提现，我们将会尽快恢复微信提现功能</div>-->
                    <div class="title">(4)支付宝提现？</div>                
                    <div class="content">&emsp;钱大师支持支付宝提现，需要收取1元手续费。</div>
                </div>

                <img src="../../assets/images/img_52.png" alt="" id="bgs">
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'关于提现',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #aboutCashOut{
        .boxPadding{
            padding: 15px;
            .explain{
                width: 345px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                position: relative;
                .text{
                    margin: 15px;
                    color: #111111;
                    font-size: 13px;
                    line-height: 18px;
                    .title{
                        font-weight: bold;
                        &:not(:first-of-type){
                            margin-top: 15px;
                        }
                    }
                }
                #bgs{
                    width: 176px;
                    height: 189px;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;
                }
            }
        }
        
    }
</style>